import React, { useId } from "react";

import {
  FieldContent,
  FieldDescription,
  FieldLabel,
  FieldTitle,
} from "@/src/components/ui/field";
import { Switch } from "@/src/components/ui/switch";

import type { JSX } from "react";

interface SectionHeaderProps {
  title: string;
  description?: string;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

function SectionHeader({
  title,
  description,
  checked,
  onCheckedChange,
}: SectionHeaderProps): JSX.Element {
  const id = useId();
  const descriptionId = `${id}-description`;
  const hasSwitch = onCheckedChange !== undefined;

  return (
    <div className="flex items-start gap-3.5">
      {hasSwitch ? (
        <Switch
          aria-describedby={description ? descriptionId : undefined}
          checked={checked}
          className="mt-0.5"
          id={id}
          onCheckedChange={onCheckedChange}
        />
      ) : null}
      <FieldContent className="gap-0.5">
        {hasSwitch ? (
          <FieldLabel className="text-base font-semibold" htmlFor={id}>
            {title}
          </FieldLabel>
        ) : (
          <FieldTitle className="text-base font-semibold">{title}</FieldTitle>
        )}
        {description ? (
          <FieldDescription id={descriptionId}>{description}</FieldDescription>
        ) : null}
      </FieldContent>
    </div>
  );
}

export default SectionHeader;
